import { USER_THEME_DARK, USER_THEME_LIGHT } from 'apps/promo/constants/Constants';

export type ThemeName = typeof USER_THEME_LIGHT | typeof USER_THEME_DARK;

export const getThemeFromUrl = (url: string): ThemeName => {
    const queryStart = url.indexOf('?');
    const mode = queryStart === -1 ? null : new URLSearchParams(url.substring(queryStart + 1)).get('mode');
    return mode === USER_THEME_DARK ? USER_THEME_DARK : USER_THEME_LIGHT;
};
